import React from 'react'

import { PacmanLoader } from 'react-spinners'
import { useI18n } from '../../i18n/I18nContext'

const ContactModal = ({ setShowModal, modalHeading, modalText }) => {
  const { t } = useI18n()

  return (
    <div className='contact-modal-container'>
      <div className='modal-content'>
        <h3>{modalHeading}</h3>
        {modalText == '' ? <PacmanLoader></PacmanLoader> : <p>{modalText}</p>}

        <button
          onClick={() => {
            setShowModal(false)
          }}
        >
          {t('contact.modalOk')}
        </button>
      </div>
    </div>
  )
}

export default ContactModal
